import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { Box } from 'src/components/Box';
import { Icon } from 'src/components/Icon';
import { Tooltip } from 'src/components/Tooltip';

export const FirstVisit = () => {
  return (
    <Tooltip title="First Visit">
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Icon
          color="primary"
          size="xsmall"
          icon={faStar}
        />
      </Box>
    </Tooltip>
  );
};
